import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "Icon / Cursor",
  "clip-path": "url(#clip0_19535_62233)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.46199 13.8646L10.0283 12.5563L5.77259 10.7143L18.2583 5.6275L13.1715 18.1132L11.3295 13.8575L9.95294 14.4534L12.2678 19.8014C12.6197 20.6146 13.7773 20.6021 14.1116 19.7815L20.0955 5.09371C20.4295 4.27384 19.612 3.4563 18.7921 3.79032L4.10433 9.77423C3.28371 10.1086 3.2712 11.2661 4.0844 11.618L9.43244 13.9329C9.66581 14.0339 9.85193 14.22 9.95294 14.4534L11.3295 13.8575C11.077 13.2741 10.6117 12.8088 10.0283 12.5563L9.46199 13.8646Z",
    fill: "#2491E7"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_19535_62233" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "white",
      transform: "matrix(-1 0 0 1 24 0)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }